export { Home } from './Home'
export { AboutJob } from './AboutJob'
export { Comments } from './Comments'
export { Questions } from './Questions'
export { Policy } from './Policy'